import { createApp } from "vue";
import calculator_fr from "./components/calculator_fr.vue";
import calculator_ch from "./components/calculator_ch.vue";
import calculator_de from "./components/calculator_de.vue";
import profile from "./components/profile/Profile.vue";
import profile_vacancy from "./components/profile/profile-vacancy.vue";
import profile_screening from "./components/profile/profile-screening.vue";

interface AppState {
    count: number;
    nonce: string;
}

const app = createApp({
    data(): AppState {
        return {
            count: 0,
            nonce: window.api_settings.nonce,
        };
    },
});

app.config.globalProperties.pll = JSON.parse(window.api_settings.translations);

import { createStore } from 'vuex';

interface State {
    currencies: any;
    currencies_list: any;
    currency_output: any;
    currency_for_calculate_taxes: string;
}

const store = createStore<State>({
    state: {
        currencies: null,
        currencies_list: null,
        currency_output: null,
        currency_for_calculate_taxes: 'EUR'
    },
    mutations: {
        currencies(state, data) {
            state.currencies = data;
        },
        currencies_list(state, data) {
            state.currencies_list = data;
        },
        currency_output(state, data) {
            state.currency_output = data;
        },
        currency_for_calculate_taxes(state, data) {
            state.currency_for_calculate_taxes = data;
        }
    }
});

app.component("calculator_fr", calculator_fr);
app.component("calculator_ch", calculator_ch);
app.component("calculator_de", calculator_de);
app.component("profile", profile);
app.component("profile-vacancy", profile_vacancy);
app.component("profile-screening", profile_screening);

app.use(store);
app.mount("#vue");